/**
 * Filtered menu to hide icon based on menu title
 */
export const menuItemIconHiddenList = [''];

/**
 * Filtered menu to hide icon based on menu title
 */
export const menuDropdownIconHiddenList = [''];
